import { Inject, NgModule } from '@angular/core';

// eslint-disable-next-line
import {
    NativeBridgeAdapter,
    NativeBridgeBootstrapperService,
    PortalNativeEventNotifier,
    VanillaDynamicComponentLoaderService,
    VanillaSmartBannerHandlerService,
} from '@frontend/oxygen/core-vanillainit';
import { VanillaAuthService, VanillaFreebetsBadgeDynamicLoaderService } from '@frontend/oxygen/lm-vanillainit';
import { MENU_COUNTERS_PROVIDER, MenuCountersProvider, MenuCountersService } from '@frontend/vanilla/core';

import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [SharedModule],
    providers: [NativeBridgeAdapter, PortalNativeEventNotifier, VanillaFreebetsBadgeDynamicLoaderService, NativeBridgeBootstrapperService],
})
export class VanillaInitModule {
    constructor(
        private vanillaDynamicComponentLoaderService: VanillaDynamicComponentLoaderService,
        private vanillaAuthService: VanillaAuthService,
        private vanillaSmartBannerHandlerService: VanillaSmartBannerHandlerService,
        private menuCountersService: MenuCountersService,
        @Inject(MENU_COUNTERS_PROVIDER) private providers: MenuCountersProvider[],
    ) {
        this.vanillaAuthService.init();
        this.vanillaDynamicComponentLoaderService.init();
        this.vanillaSmartBannerHandlerService.init();
        this.menuCountersService.registerProviders(this.providers);
    }
}
